import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

// Legacy treats an Error of one character or less as "no error"; null is tolerated
export function qaqcErrorOf(response: Dtos.QAQCResponse | null | undefined): string | null {
  const error = response?.Error?.trim();
  return error && error.length > 1 ? error : null;
}

// Lets an HTTP failure travel the same path as a QAQC-reported error
export function qaqcUnavailable(message: string): Dtos.QAQCResponse {
  return { Error: message, Results: [], RequestId: '' } as Dtos.QAQCResponse;
}

@Injectable({
  providedIn: 'root',
})
export class QAQCService {
  private http = inject(HttpClient);

  public getQAQCMilestoneBySite(event: Dtos.QAQCRequest): Observable<Dtos.QAQCResponse> {
    return this.http.post<Dtos.QAQCResponse>(`${environment.apiUrl}/pssr/qaqc/GetMilestoneBySite/`, event);
  }

  public getQAQCEventBySite(event: Dtos.QAQCRequest): Observable<Dtos.QAQCResponse> {
    return this.http.post<Dtos.QAQCResponse>(`${environment.apiUrl}/pssr/qaqc/GetEventBySite/`, event);
  }

  public getQAQCWorkOrderByMilestone(event: Dtos.QAQCRequest): Observable<Dtos.QAQCResponse> {
    return this.http.post<Dtos.QAQCResponse>(`${environment.apiUrl}/pssr/qaqc/GetWOsByMilestone/`, event);
  }

  public getQAQCWorkOrderBySite(event: Dtos.QAQCRequest): Observable<Dtos.QAQCResponse> {
    return this.http.post<Dtos.QAQCResponse>(`${environment.apiUrl}/pssr/qaqc/GetWorkOrderBySite/`, event);
  }
}
